import { handleRequest } from '../../services'
import swal from 'sweetalert2'
import multiSelect from '../../common/MultiSelect'

const defaultState = {
  ...multiSelect.mapStates(['companies', 'employees', 'groups']),
  dates: {selected: null, loaded: []},
  statesList: [],
  filterBy: 'companies',
  search: {name: '', code: ''},
  searchStatus: {selected: {id: 'all'}, loaded: []},
  loading: false
}

const state = {...defaultState}

const getters = {
  ...multiSelect.mapGetters(['companies', 'employees', 'groups']),
  filterBy: state => state.filterBy,
  dates: state => state.dates,
  statesList: state => state.statesList,
  loading: state => state.loading,
  search: state => state.search,
  searchStatus: state => state.searchStatus
}

const mutations = {
  ...multiSelect.mapMutations(['companies', 'employees', 'groups']),
  filterBy: (state, payload) => { state.filterBy = payload },
  search: (state, payload) => { state.search = {...state.search, ...payload} },
  loading: (state, payload) => { state.loading = payload },
  dates: (state, payload) => { state.dates = {...state.dates, ...payload} },
  searchStatus: (state, payload) => { state.searchStatus = {...state.searchStatus, ...payload} },
  statesList: (state, payload) => {
    state.statesList = payload
  }
}

const actions = {
  ...multiSelect.mapActions(['companies', 'employees', 'groups']),
  filterBy: ({ commit }, payload) => { commit('filterBy', payload) },
  search: ({ commit }, payload) => { commit('search', payload) },
  loading: ({ commit }, payload) => { commit('loading', payload) },
  dates: ({ commit }, payload) => { commit('dates', payload) },
  searchStatus: ({ commit }, payload) => { commit('searchStatus', payload) },
  getStatusSheets: async ({ commit, state, rootState }) => {
    if (!state.employees.selected.length && !state.companies.selected.length && !state.groups.selected.length && !state.dates.selected) {
      return
    }
    commit('loading', true)

    try {
      const employees = state.filterBy === 'employees' ? state.employees.selected.map(i => i.id) : []
      let companies = []
      if (state.filterBy === 'companies') {
        companies = state.companies.selected.map(i => i.id)
      } else if (state.filterBy === 'groups') {
        companies = state.groups.selected.reduce((a, b) => ({companies: a.companies.concat(b.companies)})).companies.map(i => i.id)
      }

      const result = await handleRequest.statusSheets({
        compMan: rootState.userInfo.compMan.id,
        employees,
        companies,
        monthYear: state.dates.selected.id
      })
      commit('statesList', result.data.success)
    } catch (err) {
      swal({
        type: 'error',
        title: 'Aconteceu um erro.',
        text: 'Aconteceu um erro, tente novamente.'
      })
    }
    commit('loading', false)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/StatusSheets/state.js